module.exports = __webpack_public_path__ + "static/process_exporting5_1-d36674d0659d2908e96b2d5dd075ad87.jpg";